import React, { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { Timeout } from "../../functions/functions";
import { InstructionInterface, DataInstructionContext, ShowInstructionContext } from "./types";
import { EditInstructionApi } from "../../redux/instruction/instructionApiCalls";
import ShowErrorMsg from "../../HtmlComponents/ShowErrorMsg";
import ButtonsForm from "../../HtmlComponents/ButtonsForm";
import InputsInstructions from "./forms/InputsInstructions";

interface props {
  modal: boolean,
  toggle: any,
  selectedInstruction: InstructionInterface
}

const EditInstruction = ({ modal, toggle, selectedInstruction }: props) => {
  const [contentFr, setContentFr] = useState(selectedInstruction.contentFr);
  const [contentAr, setContentAr] = useState(selectedInstruction.contentAr);

  const [errors, setErrors] = useState([]);
  
  const dispatch: any = useDispatch();

  const { setShowSuccessMsg } = useContext(ShowInstructionContext)

  const [loading, setLoading] = useState(false)
    
  const handleSubmitInstruction = async (e: any) => {
    e.preventDefault();
    setLoading(true)
    try {
      const response: any = await dispatch(EditInstructionApi(selectedInstruction._id, { contentFr, contentAr }));
      if (response === true) {
        toggle();
        setShowSuccessMsg(true);
        setTimeout(() => setShowSuccessMsg(false), Timeout);
        setContentFr("");
        setContentAr("");
        setErrors([]);
      } else {
        setErrors(response);
      }
    } finally {
      setLoading(false)
    }
  };

  return (
    <DataInstructionContext.Provider value={{
      contentFr, setContentFr,
      contentAr, setContentAr
    }}>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmitInstruction}
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <InputsInstructions />
                    <ButtonsForm loading={loading} typeBtn="Modifier" toggle={toggle} />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </DataInstructionContext.Provider>
  );
};

export default EditInstruction;
